import {URL, TOKEN} from './constants';

const Request = {};

Request.get = async (url) => {
    //console.log("Request Get Called", url);
    try{
        const req = await fetch(URL+url, {
            headers: {"Authorization": "Bearer " + TOKEN}
        });
        return await req.json();
    }catch (e){ return e}
};

Request.post = async (url, body) => {
    //console.log("Request Post Called", url);
    try{
        const req = await fetch(URL+url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + TOKEN
            },
            body: JSON.stringify(body)
        });
        return await req.json();
    }catch (e) {
        console.log(e);
    }
};

export default Request;